import React from 'react';
import Signin from'./user/Signin';
import Signup from './user/Signup';
import ProfileDashboard from './user/user_dashboard/ProfileDashboard';
import HistoryDashboard from './user/user_dashboard/HistoryDashboard';
import AddressDashboard from './user/user_dashboard/AddressDashboard';

import Trades from './user/trades/Trades';
import Trade from './user/trades/Trade';
import Orders from './user/orders/Orders';
import FillOrder from './user/orders/FillOrder';
import OrderFormFinished from './user/orders/FillOrder';
import GenerateShippingCheckout from './user/orders/GenerateShippingCheckout';
import ConfirmOrder from './user/orders/ConfirmOrder';
import StripeResult from './user/orders/StripeResult';
import Order from './user/orders/Order';

import AddProduct from './user/add_product/AddProduct';
import EditProduct from './user/add_product/EditProduct';
import MyItems from './user/MyItems';
import Listings from './core/Listings';
import AdminDashboard from './admin/AdminDashboard';
import AdminRoute from './auth/AdminRoute';
import AddCategory from './admin/AddCategory';
import PrivateRoute from './auth/PrivateRoute';
import ProductPage from './core/product_page/ProductPage';
import RequestPasswordReset from './core/RequestPasswordReset';
import ResetPassword from './core/ResetPassword';
import SavePaypal from './user/SavePaypal';
import GuestCheckout from './core/product_page/GuestCheckout';
import Checkout from './core/product_page/Checkout';

import Verify from './verifier_pages/Verify';

import { BrowserRouter, Switch, Route } from 'react-router-dom';

const Routes = () => { //NOTE: implement signin redirecting to dashboard/products page if has jwt token
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/' exact component={Listings}/>
                <Route path='/password-reset-request' exact component={RequestPasswordReset}/>
                <Route path='/reset-password' exact component={ResetPassword}/>

                <Route path='/loot/:productId' exact component={ProductPage}/>
                <Route path='/guest-checkout/:productId' exact component={GuestCheckout}/>
                <PrivateRoute path='/checkout/:productId' exact component={Checkout}/>

                <PrivateRoute path='/dashboard/profile' exact component={ProfileDashboard}/>
                <PrivateRoute path='/dashboard/address' exact component={AddressDashboard}/>
                <PrivateRoute path='/dashboard/History' exact component={HistoryDashboard}/>

                <PrivateRoute path='/trades' exact component={Trades} />
                <PrivateRoute path='/user/my-items' exact component={MyItems}/>
                <PrivateRoute path='/add-loot' exact component={AddProduct}/> 
                <PrivateRoute path='/paypal-onboarding' exact component={SavePaypal}/>
                <PrivateRoute path='/edit/:productId/:userId' exact component={EditProduct}/>
                <PrivateRoute path='/trade/:urlTradeId' exact component={Trade}/>
                <PrivateRoute path='/orders' exact component={Orders}/>
                <PrivateRoute path='/order/:orderId' exact component={FillOrder}/>
                <PrivateRoute path='/order-form-finished' exact component={OrderFormFinished}/>
                <PrivateRoute path='/order/generate-shipping/:orderId' exact component={GenerateShippingCheckout}/>
                <PrivateRoute path='/confirm-order/:orderId' exact component={ConfirmOrder}/>
                <PrivateRoute path='/order/order-status/:orderId' exact component={Order}/>
                
                <AdminRoute path='/verify' exact component={Verify} />

                <AdminRoute path='/admin/dashboard' exact component={AdminDashboard} />
                
                <AdminRoute path='/create/category' exact component={AddCategory} />
                
            </Switch>
        </BrowserRouter>
    );
};

export default Routes;
